var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowWithRadius({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.480278 7.3316C-0.0793818 6.61016 -0.0793814 5.60127 0.480278 4.87983L3.51262 0.970922C4.68063 -0.534731 7.09287 0.291225 7.09287 2.19681L7.09287 10.0146C7.09287 11.9202 4.68063 12.7462 3.51261 11.2405L0.480278 7.3316Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowWithRadius);
export default __webpack_public_path__ + "static/media/BackArrowWithRadius.61b572ca42afeb583e5331966a186af6.svg";
export { ForwardRef as ReactComponent };